import { useEffect, useRef } from "react";

import useTrackHeight from "../../../../../../../utils/use-track-height";
import { useAppDispatch } from "../../../../../../../store/reducers/use-typed-selector";
import { setAdminSubPanelHeaderHeight } from "../../../../../../../store/actions/admin/create-event";

import './sub-panel-wrapper.scss';
import classNames from "classnames";
import Icon, { COLORS, ICONS } from "@general-ui/icon";
import { OptionalComponent } from "@/utils/optional-component";

const SubPanelWrapper: React.FC<{
	children: JSX.Element,
	id?: string
	title?: string
}> = ({
	children,
	id,
	title
}) => {
		const dispatch = useAppDispatch();

		// set admin header height in redux so we can use it to adjust heights of other components
		const subPanelHeaderWrapperRef = useRef<HTMLDivElement>(null);
		const { height: adminHeaderHeight } = useTrackHeight({ ref: subPanelHeaderWrapperRef.current });
		useEffect(() => {
			dispatch(setAdminSubPanelHeaderHeight(adminHeaderHeight));
		}, [adminHeaderHeight, dispatch]);

		return (
			<div className="sub-panel-wrapper" id={id}>
				<OptionalComponent display={!!title}>
					<div className={classNames('sub-panel-header')}>
						<div className="title">
							<div className="title-left">
								<button
									className="no-style"
									onClick={() => history.back()}>
									<Icon name={ICONS.ARROW_LEFT} size={16} color={COLORS.WHITE} />
								</button>
								<h6>{title}</h6>
							</div>
						</div>
					</div>
				</OptionalComponent>
				<div className="panel-body-v2">
					{children}
				</div>
			</div>
		);
	};

export default SubPanelWrapper;
